export default "__VITE_ASSET__ASei2_xG__"